import React from 'react';

const SupplementaryForm = ({ details = {}, onChange, countryName = 'Selected Country' }) => {
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        onChange(name, type === 'checkbox' ? checked : type === 'number' && value ? parseInt(value, 10) : value);
    };

    const handlePhotoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                onChange('photo_base64', reader.result);
            };
            reader.readAsDataURL(file);
        }
    };


    return (
        <div className="mt-8 space-y-8 bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-6 bg-gradient-to-b from-gray-50 to-white print:p-0 print:m-0 print:shadow-none print:border-none print:bg-white print-high-fidelity">
            <style dangerouslySetInnerHTML={{ __html: `
                @media print {
                    .no-print { display: none !important; }
                    body { background: white !important; font-size: 10pt !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                    .card, .bg-blue-50, .bg-indigo-50, .bg-pink-50, .bg-gray-50, .bg-amber-50 { 
                        background-color: white !important; 
                        border: 1px solid #e5e7eb !important; 
                        box-shadow: none !important;
                    }
                    .input-field { 
                        border: 1px solid #e5e7eb !important; 
                        background: white !important; 
                        color: black !important;
                        height: 2.2rem !important;
                        padding: 0 0.5rem !important;
                        -webkit-print-color-adjust: exact !important;
                    }
                    div, h1, h2, h3, h4, p, span, label {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                }
            `}} />
            
            <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-6 border-b border-gray-200 pb-6 gap-6 md:gap-0">
                <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-left">
                    <img src={process.env.PUBLIC_URL + '/logo.png'} alt="CSK Details" className="w-24 h-24 object-contain rounded drop-shadow-sm bg-white p-1 border border-gray-100" />
                    <div>
                        <h2 className="text-2xl md:text-3xl font-extrabold text-blue-900 tracking-tight">C.S.K Language & Consultancy P. Ltd.</h2>
                        <p className="text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-widest mt-1">Application Form - {countryName} Region</p>
                        <p className="text-xs text-gray-400 mt-1 print:block hidden">Regd. No.: 48708/064/065 | Putalisadak, Kathmandu</p>
                    </div>
                </div>

                <div className="flex flex-col items-center">
                    <label className="cursor-pointer border-2 border-dashed border-gray-300 w-28 h-36 flex flex-col items-center justify-center bg-gray-50 rounded bg-center bg-contain bg-no-repeat hover:border-blue-500 transition-colors group relative overflow-hidden" style={details.photo_base64 ? { backgroundImage: `url(${details.photo_base64})` } : {}}>
                        {!details.photo_base64 && (
                            <div className="text-center p-2">
                                <span className="text-2xl opacity-50 group-hover:opacity-100 transition-opacity">📸</span>
                                <p className="text-[10px] font-semibold text-gray-400 mt-2 uppercase">Attach 2x2<br/>Photo</p>
                            </div>
                        )}
                        <input type="file" accept="image/*" className="hidden no-print" onChange={handlePhotoUpload} />
                    </label>
                </div>
            </div>

            <div className="space-y-8">
                <div>
                  <h3 className="text-lg font-bold text-indigo-800 border-b-2 border-indigo-100 pb-2 mb-4 flex items-center gap-2"><span className="text-xl">👤</span> Personal Details</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                      <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Family Name <span className="text-red-500 no-print">*</span></label>
                          <input type="text" name="family_name" value={details.family_name || ''} onChange={handleChange} className="input-field" placeholder="e.g. Doe" />
                      </div>
                      <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Given Name <span className="text-red-500 no-print">*</span></label>
                          <input type="text" name="given_name" value={details.given_name || ''} onChange={handleChange} className="input-field" placeholder="e.g. John" />
                      </div>
                      <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Marital Status <span className="text-red-500 no-print">*</span></label>
                          <select name="marital_status" value={details.marital_status || ''} onChange={handleChange} className="input-field">
                              <option value="">Select Status</option>
                              <option value="Single">Single</option>
                              <option value="Married">Married</option>
                          </select>
                      </div>
                      <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Place of Birth <span className="text-red-500 no-print">*</span></label>
                          <input type="text" name="place_of_birth" value={details.place_of_birth || ''} onChange={handleChange} className="input-field" placeholder="City, Country" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Native Language <span className="text-red-500 no-print">*</span></label>
                         <input type="text" name="native_language" value={details.native_language || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Tel No. 1 <span className="text-red-500 no-print">*</span></label>
                          <input type="text" name="tel_no_1" value={details.tel_no_1 || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Tel No. 2</label>
                          <input type="text" name="tel_no_2" value={details.tel_no_2 || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div className="col-span-1 md:col-span-2">
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Current Address <span className="text-red-500 no-print">*</span></label>
                         <input type="text" name="current_address" value={details.current_address || ''} onChange={handleChange} className="input-field" />
                      </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-bold text-indigo-800 border-b-2 border-indigo-100 pb-2 mb-4 flex items-center gap-2"><span className="text-xl">✈️</span> Passport & Travel Information</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                      <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Passport Issue Date <span className="text-red-500 no-print">*</span></label>
                          <input type="date" name="passport_issue_date" value={details.passport_issue_date || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                          <label className="block text-sm font-semibold mb-1 text-gray-700">Passport Expiry Date <span className="text-red-500 no-print">*</span></label>
                          <input type="date" name="passport_expiry_date" value={details.passport_expiry_date || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Issuing Authority <span className="text-red-500 no-print">*</span></label>
                         <input type="text" name="issuing_authority" value={details.issuing_authority || ''} onChange={handleChange} className="input-field" placeholder="e.g. MOFA" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Place to Apply for Visa</label>
                         <input type="text" name="place_to_apply_for_visa" value={details.place_to_apply_for_visa || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div className="pt-6">
                          <label className="inline-flex items-center gap-3 text-sm font-semibold text-gray-800 bg-gray-100 px-4 py-2 rounded-lg cursor-pointer hover:bg-gray-200 transition-colors no-print">
                              <input type="checkbox" name="past_entry" checked={details.past_entry || false} onChange={handleChange} className="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 cursor-pointer" />
                              Past Entry into {countryName}
                          </label>
                          <div className="hidden print:block input-field flex items-center">
                               Past Entry: {details.past_entry ? `Yes (${details.past_entry_times || 1} times)` : 'Never'}
                          </div>
                      </div>
                  </div>
                </div>

                <div className="break-before-page">
                  <h3 className="text-lg font-bold text-indigo-800 border-b-2 border-indigo-100 pb-2 mb-4 flex items-center gap-2"><span className="text-xl">🤝</span> Sponsor Information</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Sponsor Name <span className="text-red-500 no-print">*</span></label>
                         <input type="text" name="sponsor_name" value={details.sponsor_name || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Relationship <span className="text-red-500 no-print">*</span></label>
                         <input type="text" name="sponsor_relationship" value={details.sponsor_relationship || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Occupation</label>
                         <input type="text" name="sponsor_occupation" value={details.sponsor_occupation || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div className="col-span-1 md:col-span-2">
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Address</label>
                         <input type="text" name="sponsor_address" value={details.sponsor_address || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">College Name (If Bachelor)</label>
                         <input type="text" name="sponsor_college" value={details.sponsor_college || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Company Name (If Working)</label>
                         <input type="text" name="sponsor_company" value={details.sponsor_company || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Company Tel No.</label>
                         <input type="text" name="sponsor_company_tel" value={details.sponsor_company_tel || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Sponsor's Father Contact</label>
                         <input type="text" name="sponsor_father_number" value={details.sponsor_father_number || ''} onChange={handleChange} className="input-field" />
                      </div>
                      <div>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Sponsor's Mother Contact</label>
                         <input type="text" name="sponsor_mother_number" value={details.sponsor_mother_number || ''} onChange={handleChange} className="input-field" />
                      </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-bold text-indigo-800 border-b-2 border-indigo-100 pb-2 mb-4 flex items-center gap-2"><span className="text-xl">👨‍👩‍👦</span> Family Details</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100 print:bg-white print:border-gray-200">
                         <h4 className="font-bold text-blue-800 mb-3 text-sm">Father Details</h4>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Name <span className="text-red-500 no-print">*</span></label>
                         <input type="text" name="father_name" value={details.father_name || ''} onChange={handleChange} className="input-field mb-3 bg-white" />
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Date of Birth</label>
                         <input type="date" name="father_dob" value={details.father_dob || ''} onChange={handleChange} className="input-field bg-white" />
                      </div>
                      <div className="bg-pink-50/50 p-4 rounded-xl border border-pink-100 print:bg-white print:border-gray-200">
                         <h4 className="font-bold text-pink-800 mb-3 text-sm">Mother Details</h4>
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Name <span className="text-red-500 no-print">*</span></label>
                         <input type="text" name="mother_name" value={details.mother_name || ''} onChange={handleChange} className="input-field mb-3 bg-white" />
                         <label className="block text-sm font-semibold mb-1 text-gray-700">Date of Birth</label>
                         <input type="date" name="mother_dob" value={details.mother_dob || ''} onChange={handleChange} className="input-field bg-white" />
                      </div>
                  </div>
                </div>

                <div className="bg-amber-50 p-6 rounded-xl border-l-4 border-amber-500 mt-6 print:bg-white print:border-gray-200">
                    <div className="mb-4">
                        <h4 className="font-bold text-gray-800 mb-2 uppercase text-sm underline">Points to Remember & Declaration</h4>
                    </div>
                    <ul className="list-disc pl-6 space-y-2 text-amber-800 text-sm font-medium print:text-gray-700">
                        <li>Only for student who wish to apply in student visa for {countryName}.</li>
                        <li>Documents are prepared according to the information filled in this form so all the data should be correct and true.</li>
                    </ul>
                    
                    {/* Print Only Signature Section */}
                    <div className="mt-16 hidden print:flex justify-between items-end">
                        <div className="text-center w-64 border-t border-black pt-2">
                            <p className="text-xs font-bold uppercase tracking-widest text-gray-800">Applicant's Signature</p>
                            <p className="text-[8pt] text-gray-400 mt-1">Date: {new Date().toLocaleDateString()}</p>
                        </div>
                        <div className="text-center w-64 border-t border-black pt-2">
                            <p className="text-xs font-bold uppercase tracking-widest text-blue-900">Counselor Verification</p>
                            <p className="text-[8pt] text-gray-400 mt-1">(Seal & Authorized Sign)</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default SupplementaryForm;
